import { useSuspenseQuery } from '@tanstack/react-query';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { opsQueryKeys } from 'queries/ops-query-keys';

const useRemoteStaticAssets = () => {
    const account = useCurrentAccount();

    useSuspenseQuery({
        queryKey: opsQueryKeys.editorCustomCss(),
        queryFn: async () => loadCSS(account.editorCustomCss),
    });
};

const loadCSS = (url: string): Promise<null> => {
    return new Promise((resolve, reject) => {
        if (document.querySelector(`link[href="${url}"]`)) {
            resolve(null);
            return;
        }

        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = url;
        link.type = 'text/css';
        link.onload = () => resolve(null);
        link.onerror = () => reject(new Error(`Failed to load CSS: ${url}`));
        document.head.appendChild(link);
    });
};

export { useRemoteStaticAssets };
